import { createSlice } from '@reduxjs/toolkit';
import type { PhysicalGiftCardConfig } from '../../domain/models/storeGiftCard.types';

export const STORE_GIFT_CARD_INITIAL_SLICE_NAME = 'storeGiftCardInitial';

export interface StoreGiftCardInitialState {
  /** Gift card config from SSR; used so client does not refetch on hydration. */
  data: PhysicalGiftCardConfig | null;
}

const initialState: StoreGiftCardInitialState = {
  data: null,
};

const storeGiftCardInitialSlice = createSlice({
  name: STORE_GIFT_CARD_INITIAL_SLICE_NAME,
  initialState,
  reducers: {
    setStoreGiftCardInitialData(state, action: { payload: PhysicalGiftCardConfig | null }) {
      state.data = action.payload ?? null;
    },
    clearStoreGiftCardInitialData(state) {
      state.data = null;
    },
  },
});

export const storeGiftCardInitialReducer = storeGiftCardInitialSlice.reducer;
export const { setStoreGiftCardInitialData, clearStoreGiftCardInitialData } =
  storeGiftCardInitialSlice.actions;

export function selectStoreGiftCardInitialConfig(state: {
  [STORE_GIFT_CARD_INITIAL_SLICE_NAME]?: StoreGiftCardInitialState;
}): PhysicalGiftCardConfig | null {
  return state[STORE_GIFT_CARD_INITIAL_SLICE_NAME]?.data ?? null;
}
